import {StyleSheet} from "aphrodite";

import Button from "@khanacademy/wonder-blocks-button";
import type {StyleType} from "@khanacademy/wonder-blocks-core";
import {doNotTranslateYet} from "@khan/i18n";
import {mediaQueries} from "@khan/shared-styles";

import type {WorkerStatus} from "./python-coding-page.tsx";
import {createPrimaryButtonStyle} from "./utils.ts";

import runIcon from "@phosphor-icons/core/fill/play-fill.svg";
import stopIcon from "@phosphor-icons/core/fill/stop-fill.svg";

type Props = {
    onRunCode: () => void;
    onStopRunningCode: () => void;
    size?: "small" | "medium" | "large";
    status: WorkerStatus;
    style?: StyleType;
    useEmbeddedStyles?: boolean;
};

const RunButton = ({
    onRunCode,
    onStopRunningCode,
    size,
    status,
    style,
    useEmbeddedStyles,
}: Props) => {
    const styles = useEmbeddedStyles ? embeddedStyles : standaloneStyles;
    if (status === "ready") {
        return (
            <Button
                disabled={false}
                onClick={onRunCode}
                size={size}
                startIcon={runIcon}
                style={[styles.button, styles.runButton, style]}
            >
                {doNotTranslateYet`Run`}
            </Button>
        );
    }

    if (status === "running") {
        return (
            <Button
                kind="secondary"
                onClick={onStopRunningCode}
                size={size}
                startIcon={stopIcon}
                style={[styles.button, style]}
            >
                {doNotTranslateYet`Stop`}
            </Button>
        );
    }

    return (
        <Button
            disabled={true}
            size={size}
            spinner={true}
            style={[styles.button, style]}
        >
            {doNotTranslateYet`Run`}
        </Button>
    );
};

// As of 2024-05-16, the Wonder Blocks green doesn't have high enough contrast
// for accessibility requirements, so we use a slightly darker green. There
// is currently an effort underway to make the WB colors more accessible.
// TODO: Once an accessible green is defined in Wonder Blocks, use that color
//  instead.
const buttonGreen = "#00880B";

/* eslint-disable react-native/no-unused-styles */
const getStyles = (useEmbeddedStyles: boolean) =>
    StyleSheet.create({
        button: {
            [useEmbeddedStyles
                ? mediaQueries.smOrLarger
                : mediaQueries.mdOrLarger]: {
                justifySelf: "center",
            },
        },
        runButton: createPrimaryButtonStyle(buttonGreen),
    });

const embeddedStyles = getStyles(true);
const standaloneStyles = getStyles(false);

export default RunButton;
